// GENERATED FILE - DO NOT MODIFY

export enum ScheduleEventSourceDto {
    DefaultSchedule = "DefaultSchedule",
    PersistedSchedule = "PersistedSchedule",
}